import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {UserNotesComponent} from '@catmodules/widgets/user-notes/components/user-notes.component';
import {UIBaseModule} from '@catui/ui-base.module';
import {EditorModule} from 'primeng/primeng';

const publicComponents = [UserNotesComponent];

@NgModule({
  imports: [
    BrowserAnimationsModule,
    UIBaseModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    ...publicComponents,
  ],
  exports: [...publicComponents],
})
export class UserNotesModule {
  static forRoot(): ModuleWithProviders {
    return {ngModule: UserNotesModule, providers: []};
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/widgets/user-notes/user-notes.module.ts